import { motion } from "framer-motion";
import { PhoneCall } from "lucide-react";
import { HERO_VIDEO, CONTACT } from "../data";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => {
  return (
    <section
      id="start"
      data-testid="hero-section"
      className="relative min-h-[88vh] flex items-center pt-16 md:pt-20 bg-[#09090B] overflow-hidden"
    >
      {/* Full-bleed background video */}
      <video
        data-testid="hero-video"
        className="absolute inset-0 w-full h-full object-cover"
        src={HERO_VIDEO.src}
        poster={HERO_VIDEO.poster}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
      />
      {/* Gradient overlays: darker left for text, lighter right to keep Bobcat visible */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#09090B] via-[#09090B]/80 to-[#09090B]/20" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#09090B]/70 via-transparent to-[#09090B]/30" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <span className="inline-block bg-[#DC2626] text-white font-anton uppercase tracking-widest text-sm px-4 py-1.5 mb-6">
            Usługi sprzętem Bobcat
          </span>
          <h1
            data-testid="hero-headline"
            className="font-anton uppercase text-white text-4xl sm:text-5xl md:text-7xl leading-[0.95] tracking-tight drop-shadow-[0_2px_12px_rgba(0,0,0,0.6)]"
          >
            Usługi nowoczesnym{" "}
            <span className="text-[#DC2626]">sprzętem Bobcat</span>
          </h1>
          <p
            data-testid="hero-subheadline"
            className="mt-6 text-zinc-100 text-base md:text-lg max-w-xl leading-relaxed drop-shadow-[0_2px_8px_rgba(0,0,0,0.7)]"
          >
            Mulczowanie, czyszczenie działek, frezowanie pni, prace minikoparką,
            wyburzenia, odśnieżanie i inne usługi sprzętem Bobcat.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <a
              data-testid="hero-cta-call"
              href={CONTACT.phoneLink}
              className="group bg-[#DC2626] text-white font-anton uppercase tracking-wider px-8 py-4 flex items-center justify-center gap-2 hover:bg-white hover:text-[#09090B] transition-colors"
            >
              <PhoneCall size={20} />
              Zadzwoń teraz
            </a>
            <button
              data-testid="hero-cta-realizacje"
              onClick={() => scrollTo("realizacje")}
              className="border-2 border-white text-white font-anton uppercase tracking-wider px-8 py-4 hover:bg-white hover:text-[#09090B] transition-colors"
            >
              Zobacz realizacje
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
